<script setup>
import { useI18n } from 'vue-i18n';

import AuditTrailChange from './AuditTrailChange.vue';

defineProps({
  model: { type: String, required: true },
  action: { type: String, required: true },
  changes: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
</script>

<template>
  <template v-if="action === 'create'">
    <AuditTrailChange
      v-for="(change, field) in changes"
      :key="field"
      :action="action"
      :field-name="field"
      :field-value="change"
    />
  </template>

  <template v-else-if="action === 'destroy'">
    <AuditTrailChange
      v-for="(change, field) in changes"
      :key="field"
      :action="action"
      :field-name="field"
      :field-value="change"
    />
  </template>

  <template v-else-if="action === 'sign_in'">
    <div class="text-sm font-medium text-n-slate-12">
      {{ t('WGPT_AUDIT_TRAIL.COMMON.SIGNED_IN') }}
    </div>
  </template>

  <template v-else-if="action === 'sign_out'">
    <div class="text-sm font-medium text-n-slate-12">
      {{ t('WGPT_AUDIT_TRAIL.COMMON.SIGNED_OUT') }}
    </div>
  </template>

  <template v-else-if="action === 'update'">
    <AuditTrailChange
      v-for="(change, field) in changes"
      :key="field"
      :action="action"
      :field-name="field"
      :field-value="change"
    />
  </template>

  <template v-else>
    <div class="text-sm font-medium text-n-slate-12">
      {{ action }} {{ model }}
    </div>
  </template>
</template>
